export default "__VITE_ASSET__CWLoMqZT__"